/**
 * RMS (Raw Material) to Standard Mapping
 * Used to filter available raw materials based on selected facility standards
 * Source: certified-rms.json from backend (exact 1:1 copy — do not edit manually)
 */

export interface RmsStandardMapping {
  standard: string;
  material_code: string;
}

// Complete mapping — exact copy of Backend/function-app/scope_certificate/utilities/certified-rms.json
export const RMS_STANDARD_MAPPING: RmsStandardMapping[] = [
  { standard: "NA", material_code: "RM0001" },
  { standard: "OCS", material_code: "RM0002" },
  { standard: "OCS", material_code: "RM0003" },
  { standard: "RCS/GRS", material_code: "RM0005" },
  { standard: "RCS/GRS", material_code: "RM0006" },
  { standard: "RAS", material_code: "RM0007" },
  { standard: "NA", material_code: "RM0008" },
  { standard: "OCS", material_code: "RM0009" },
  { standard: "OCS", material_code: "RM0010" },
  { standard: "RCS/GRS", material_code: "RM0012" },
  { standard: "RCS/GRS", material_code: "RM0013" },
  { standard: "NA", material_code: "RM0014" },
  { standard: "OCS", material_code: "RM0015" },
  { standard: "OCS", material_code: "RM0016" },
  { standard: "RCS/GRS", material_code: "RM0018" },
  { standard: "RCS/GRS", material_code: "RM0019" },
  { standard: "NA", material_code: "RM0020" },
  { standard: "OCS", material_code: "RM0021" },
  { standard: "OCS", material_code: "RM0022" },
  { standard: "RCS/GRS", material_code: "RM0024" },
  { standard: "RCS/GRS", material_code: "RM0025" },
  { standard: "NA", material_code: "RM0026" },
  { standard: "OCS", material_code: "RM0027" },
  { standard: "OCS", material_code: "RM0028" },
  { standard: "RCS/GRS", material_code: "RM0030" },
  { standard: "RCS/GRS", material_code: "RM0031" },
  { standard: "RDS", material_code: "RM0032" },
  { standard: "NA", material_code: "RM0033" },
  { standard: "OCS", material_code: "RM0034" },
  { standard: "OCS", material_code: "RM0035" },
  { standard: "RCS/GRS", material_code: "RM0037" },
  { standard: "RCS/GRS", material_code: "RM0038" },
  { standard: "RDS", material_code: "RM0039" },
  { standard: "NA", material_code: "RM0040" },
  { standard: "OCS", material_code: "RM0041" },
  { standard: "OCS", material_code: "RM0042" },
  { standard: "RCS/GRS", material_code: "RM0044" },
  { standard: "RCS/GRS", material_code: "RM0045" },
  { standard: "NA", material_code: "RM0046" },
  { standard: "OCS", material_code: "RM0047" },
  { standard: "OCS", material_code: "RM0048" },
  { standard: "RCS/GRS", material_code: "RM0050" },
  { standard: "RCS/GRS", material_code: "RM0051" },
  { standard: "NA", material_code: "RM0052" },
  { standard: "OCS", material_code: "RM0053" },
  { standard: "OCS", material_code: "RM0054" },
  { standard: "RCS/GRS", material_code: "RM0056" },
  { standard: "RCS/GRS", material_code: "RM0057" },
  { standard: "NA", material_code: "RM0058" },
  { standard: "OCS", material_code: "RM0059" },
  { standard: "OCS", material_code: "RM0060" },
  { standard: "RCS/GRS", material_code: "RM0062" },
  { standard: "RCS/GRS", material_code: "RM0063" },
  { standard: "RMS", material_code: "RM0064" },
  { standard: "NA", material_code: "RM0065" },
  { standard: "OCS", material_code: "RM0066" },
  { standard: "OCS", material_code: "RM0067" },
  { standard: "RCS/GRS", material_code: "RM0069" },
  { standard: "RCS/GRS", material_code: "RM0070" },
  { standard: "NA", material_code: "RM0071" },
  { standard: "OCS", material_code: "RM0072" },
  { standard: "OCS", material_code: "RM0073" },
  { standard: "RCS/GRS", material_code: "RM0075" },
  { standard: "RCS/GRS", material_code: "RM0076" },
  { standard: "NA", material_code: "RM0077" },
  { standard: "OCS", material_code: "RM0078" },
  { standard: "OCS", material_code: "RM0079" },
  { standard: "RCS/GRS", material_code: "RM0081" },
  { standard: "RCS/GRS", material_code: "RM0082" },
  { standard: "RWS", material_code: "RM0083" },
  { standard: "NA", material_code: "RM0084" },
  { standard: "OCS", material_code: "RM0085" },
  { standard: "OCS", material_code: "RM0086" },
  { standard: "RCS/GRS", material_code: "RM0088" },
  { standard: "RCS/GRS", material_code: "RM0089" },
  { standard: "NA", material_code: "RM0090" },
  { standard: "OCS", material_code: "RM0091" },
  { standard: "OCS", material_code: "RM0092" },
  { standard: "RCS/GRS", material_code: "RM0094" },
  { standard: "RCS/GRS", material_code: "RM0095" },
  { standard: "NA", material_code: "RM0096" },
  { standard: "OCS", material_code: "RM0097" },
  { standard: "OCS", material_code: "RM0098" },
  { standard: "RCS/GRS", material_code: "RM0100" },
  { standard: "RCS/GRS", material_code: "RM0101" },
  { standard: "NA", material_code: "RM0102" },
  { standard: "OCS", material_code: "RM0103" },
  { standard: "OCS", material_code: "RM0104" },
  { standard: "RCS/GRS", material_code: "RM0106" },
  { standard: "RCS/GRS", material_code: "RM0107" },
  { standard: "NA", material_code: "RM0108" },
  { standard: "OCS", material_code: "RM0109" },
  { standard: "OCS", material_code: "RM0110" },
  { standard: "RCS/GRS", material_code: "RM0112" },
  { standard: "RCS/GRS", material_code: "RM0113" },
  { standard: "NA", material_code: "RM0114" },
  { standard: "OCS", material_code: "RM0115" },
  { standard: "OCS", material_code: "RM0116" },
  { standard: "RCS/GRS", material_code: "RM0118" },
  { standard: "RCS/GRS", material_code: "RM0119" },
  { standard: "NA", material_code: "RM0120" },
  { standard: "OCS", material_code: "RM0121" },
  { standard: "OCS", material_code: "RM0122" },
  { standard: "RCS/GRS", material_code: "RM0124" },
  { standard: "RCS/GRS", material_code: "RM0125" },
  { standard: "NA", material_code: "RM0126" },
  { standard: "OCS", material_code: "RM0127" },
  { standard: "OCS", material_code: "RM0128" },
  { standard: "RCS/GRS", material_code: "RM0130" },
  { standard: "RCS/GRS", material_code: "RM0131" },
  { standard: "NA", material_code: "RM0132" },
  { standard: "OCS", material_code: "RM0133" },
  { standard: "OCS", material_code: "RM0134" },
  { standard: "RCS/GRS", material_code: "RM0136" },
  { standard: "RCS/GRS", material_code: "RM0137" },
  { standard: "NA", material_code: "RM0138" },
  { standard: "OCS", material_code: "RM0139" },
  { standard: "OCS", material_code: "RM0140" },
  { standard: "RCS/GRS", material_code: "RM0142" },
  { standard: "RCS/GRS", material_code: "RM0143" },
  { standard: "NA", material_code: "RM0144" },
  { standard: "OCS", material_code: "RM0145" },
  { standard: "OCS", material_code: "RM0146" },
  { standard: "RCS/GRS", material_code: "RM0148" },
  { standard: "RCS/GRS", material_code: "RM0149" },
  { standard: "NA", material_code: "RM0150" },
  { standard: "OCS", material_code: "RM0151" },
  { standard: "OCS", material_code: "RM0152" },
  { standard: "RCS/GRS", material_code: "RM0154" },
  { standard: "RCS/GRS", material_code: "RM0155" },
  { standard: "NA", material_code: "RM0156" },
  { standard: "RCS/GRS", material_code: "RM0158" },
  { standard: "RCS/GRS", material_code: "RM0159" },
  { standard: "NA", material_code: "RM0160" },
  { standard: "RCS/GRS", material_code: "RM0162" },
  { standard: "RCS/GRS", material_code: "RM0163" },
  { standard: "NA", material_code: "RM0164" },
  { standard: "RCS/GRS", material_code: "RM0166" },
  { standard: "RCS/GRS", material_code: "RM0167" },
  { standard: "NA", material_code: "RM0168" },
  { standard: "RCS/GRS", material_code: "RM0170" },
  { standard: "RCS/GRS", material_code: "RM0171" },
  { standard: "NA", material_code: "RM0172" },
  { standard: "OCS", material_code: "RM0173" },
  { standard: "OCS", material_code: "RM0174" },
  { standard: "RCS/GRS", material_code: "RM0176" },
  { standard: "RCS/GRS", material_code: "RM0177" },
  { standard: "NA", material_code: "RM0178" },
  { standard: "RCS/GRS", material_code: "RM0180" },
  { standard: "RCS/GRS", material_code: "RM0181" },
  { standard: "NA", material_code: "RM0182" },
  { standard: "RCS/GRS", material_code: "RM0184" },
  { standard: "RCS/GRS", material_code: "RM0185" },
  { standard: "NA", material_code: "RM0186" },
  { standard: "RCS/GRS", material_code: "RM0188" },
  { standard: "RCS/GRS", material_code: "RM0189" },
  { standard: "NA", material_code: "RM0190" },
  { standard: "RCS/GRS", material_code: "RM0192" },
  { standard: "RCS/GRS", material_code: "RM0193" },
  { standard: "NA", material_code: "RM0194" },
  { standard: "RCS/GRS", material_code: "RM0196" },
  { standard: "RCS/GRS", material_code: "RM0197" },
  { standard: "NA", material_code: "RM0198" },
  { standard: "RCS/GRS", material_code: "RM0200" },
  { standard: "RCS/GRS", material_code: "RM0201" },
  { standard: "NA", material_code: "RM0202" },
  { standard: "RCS/GRS", material_code: "RM0204" },
  { standard: "RCS/GRS", material_code: "RM0205" },
  { standard: "NA", material_code: "RM0206" },
  { standard: "RCS/GRS", material_code: "RM0208" },
  { standard: "RCS/GRS", material_code: "RM0209" },
  { standard: "NA", material_code: "RM0210" },
  { standard: "RCS/GRS", material_code: "RM0212" },
  { standard: "RCS/GRS", material_code: "RM0213" },
  { standard: "NA", material_code: "RM0214" },
  { standard: "RCS/GRS", material_code: "RM0216" },
  { standard: "RCS/GRS", material_code: "RM0217" },
  { standard: "NA", material_code: "RM0218" },
  { standard: "RCS/GRS", material_code: "RM0220" },
  { standard: "RCS/GRS", material_code: "RM0221" },
  { standard: "NA", material_code: "RM0222" },
  { standard: "RCS/GRS", material_code: "RM0224" },
  { standard: "RCS/GRS", material_code: "RM0225" },
  { standard: "NA", material_code: "RM0226" },
  { standard: "RCS/GRS", material_code: "RM0228" },
  { standard: "RCS/GRS", material_code: "RM0229" },
  { standard: "NA", material_code: "RM0230" },
  { standard: "RCS/GRS", material_code: "RM0232" },
  { standard: "RCS/GRS", material_code: "RM0233" },
  { standard: "NA", material_code: "RM0234" },
  { standard: "RCS/GRS", material_code: "RM0236" },
  { standard: "RCS/GRS", material_code: "RM0237" },
  { standard: "NA", material_code: "RM0238" },
  { standard: "RCS/GRS", material_code: "RM0240" },
  { standard: "RCS/GRS", material_code: "RM0241" },
  { standard: "NA", material_code: "RM0242" },
  { standard: "RCS/GRS", material_code: "RM0244" },
  { standard: "RCS/GRS", material_code: "RM0245" },
  { standard: "NA", material_code: "RM0246" },
  { standard: "RCS/GRS", material_code: "RM0248" },
  { standard: "RCS/GRS", material_code: "RM0249" },
  { standard: "NA", material_code: "RM0250" },
  { standard: "RCS/GRS", material_code: "RM0252" },
  { standard: "RCS/GRS", material_code: "RM0253" },
  { standard: "NA", material_code: "RM0254" },
  { standard: "RCS/GRS", material_code: "RM0256" },
  { standard: "RCS/GRS", material_code: "RM0257" },
  { standard: "NA", material_code: "RM0258" },
  { standard: "RCS/GRS", material_code: "RM0260" },
  { standard: "RCS/GRS", material_code: "RM0261" },
  { standard: "NA", material_code: "RM0262" },
  { standard: "OCS", material_code: "RM0263" },
  { standard: "OCS", material_code: "RM0264" },
  { standard: "RCS/GRS", material_code: "RM0266" },
  { standard: "RCS/GRS", material_code: "RM0267" },
  { standard: "NA", material_code: "RM0268" },
  { standard: "RCS/GRS", material_code: "RM0270" },
  { standard: "RCS/GRS", material_code: "RM0271" },
  { standard: "NA", material_code: "RM0272" },
  { standard: "RCS/GRS", material_code: "RM0274" },
  { standard: "RCS/GRS", material_code: "RM0275" },
  { standard: "NA", material_code: "RM0276" },
  { standard: "RCS/GRS", material_code: "RM0278" },
  { standard: "RCS/GRS", material_code: "RM0279" },
  { standard: "NA", material_code: "RM0280" },
  { standard: "RCS/GRS", material_code: "RM0282" },
  { standard: "RCS/GRS", material_code: "RM0283" },
  { standard: "NA", material_code: "RM0284" },
  { standard: "RCS/GRS", material_code: "RM0286" },
  { standard: "RCS/GRS", material_code: "RM0287" },
  { standard: "NA", material_code: "RM0288" },
  { standard: "RCS/GRS", material_code: "RM0290" },
  { standard: "RCS/GRS", material_code: "RM0291" },
  { standard: "NA", material_code: "RM0292" },
  { standard: "RCS/GRS", material_code: "RM0294" },
  { standard: "RCS/GRS", material_code: "RM0295" },
  { standard: "NA", material_code: "RM0296" },
  { standard: "RCS/GRS", material_code: "RM0298" },
  { standard: "RCS/GRS", material_code: "RM0299" },
  { standard: "NA", material_code: "RM0300" },
  { standard: "RCS/GRS", material_code: "RM0302" },
  { standard: "RCS/GRS", material_code: "RM0303" },
  { standard: "GOTS", material_code: "RM0304" },
  { standard: "CCS", material_code: "RM0305" },
  { standard: "RCS/GRS", material_code: "RM0306" },
  { standard: "RCS/GRS", material_code: "RM0307" },
  { standard: "RCS/GRS", material_code: "RM0308" },
  { standard: "RCS/GRS", material_code: "RM0309" },
  { standard: "RCS/GRS", material_code: "RM0310" },
  { standard: "RCS/GRS", material_code: "RM0311" },
  { standard: "RCS/GRS", material_code: "RM0312" },
  { standard: "RCS/GRS", material_code: "RM0313" },
  { standard: "RCS/GRS", material_code: "RM0314" },
  { standard: "RCS/GRS", material_code: "RM0315" },
  { standard: "RCS/GRS", material_code: "RM0316" },
  { standard: "RCS/GRS", material_code: "RM0317" },
  { standard: "RCS/GRS", material_code: "RM0318" },
  { standard: "RCS/GRS", material_code: "RM0319" },
  { standard: "RCS/GRS", material_code: "RM0320" },
  { standard: "RCS/GRS", material_code: "RM0321" },
  { standard: "RCS/GRS", material_code: "RM0322" },
  { standard: "RCS/GRS", material_code: "RM0323" },
  { standard: "RCS/GRS", material_code: "RM0324" },
  { standard: "RCS/GRS", material_code: "RM0325" },
  { standard: "RCS/GRS", material_code: "RM0326" },
  { standard: "RCS/GRS", material_code: "RM0327" },
  { standard: "RDS", material_code: "RM0328" },
  { standard: "RDS", material_code: "RM0330" },
  { standard: "RDS", material_code: "RM0331" },
  { standard: "OCS", material_code: "RM0332" },
  { standard: "RCS/GRS", material_code: "RM0334" },
  { standard: "RCS/GRS", material_code: "RM0335" },
  { standard: "RWS", material_code: "RM0336" },
  { standard: "NA", material_code: "RM0337" },
  { standard: "OCS", material_code: "RM0338" },
  { standard: "OCS", material_code: "RM0339" },
  { standard: "RCS/GRS", material_code: "RM0341" },
  { standard: "RCS/GRS", material_code: "RM0342" },
  { standard: "RWS", material_code: "RM0343" },
  { standard: "NA", material_code: "RM0344" },
  { standard: "OCS", material_code: "RM0345" },
  { standard: "OCS", material_code: "RM0346" },
  { standard: "RCS/GRS", material_code: "RM0348" },
  { standard: "RCS/GRS", material_code: "RM0349" },
  { standard: "RWS", material_code: "RM0350" },
  { standard: "RMS", material_code: "RM0350" },
  { standard: "RAS", material_code: "RM0350" },
  { standard: "NA", material_code: "RM0351" },
  { standard: "OCS", material_code: "RM0352" },
  { standard: "OCS", material_code: "RM0353" },
  { standard: "RCS/GRS", material_code: "RM0355" },
  { standard: "RCS/GRS", material_code: "RM0356" },
  { standard: "NA", material_code: "RM0358" },
  { standard: "OCS", material_code: "RM0359" },
  { standard: "OCS", material_code: "RM0360" },
  { standard: "RCS/GRS", material_code: "RM0362" },
  { standard: "RCS/GRS", material_code: "RM0363" },
  { standard: "NA", material_code: "RM0365" },
  { standard: "OCS", material_code: "RM0366" },
  { standard: "OCS", material_code: "RM0367" },
  { standard: "RCS/GRS", material_code: "RM0369" },
  { standard: "RCS/GRS", material_code: "RM0370" },
  { standard: "NA", material_code: "RM0372" },
  { standard: "OCS", material_code: "RM0373" },
  { standard: "OCS", material_code: "RM0374" },
  { standard: "RCS/GRS", material_code: "RM0376" },
  { standard: "RCS/GRS", material_code: "RM0377" },
  { standard: "NA", material_code: "RM0379" },
  { standard: "OCS", material_code: "RM0380" },
  { standard: "OCS", material_code: "RM0381" },
  { standard: "RCS/GRS", material_code: "RM0383" },
  { standard: "RCS/GRS", material_code: "RM0384" },
  { standard: "NA", material_code: "RM0386" },
  { standard: "RCS/GRS", material_code: "RM0389" },
  { standard: "RCS/GRS", material_code: "RM0390" },
  { standard: "RCS/GRS", material_code: "RM0391" },
  { standard: "RCS/GRS", material_code: "RM0392" },
  { standard: "NA", material_code: "RM0393" },
  { standard: "RCS/GRS", material_code: "RM0396" },
  { standard: "RCS/GRS", material_code: "RM0397" },
  { standard: "RCS/GRS", material_code: "RM0398" },
  { standard: "RCS/GRS", material_code: "RM0399" },
  { standard: "NA", material_code: "RM0426" },
  { standard: "OCS", material_code: "RM0427" },
  { standard: "RCS/GRS", material_code: "RM0428" },
  { standard: "RCS/GRS", material_code: "RM0429" },
  { standard: "NA", material_code: "RM0430" },
  { standard: "RCS/GRS", material_code: "RM0432" },
  { standard: "RCS/GRS", material_code: "RM0433" },
  { standard: "RCS/GRS", material_code: "RM0434" },
  { standard: "RCS/GRS", material_code: "RM0435" },
  { standard: "RDS", material_code: "RM0329" },
  { standard: "RCS/GRS", material_code: "RM0438" },
  { standard: "RCS/GRS", material_code: "RM0440" },
  { standard: "RCS/GRS", material_code: "RM0442" },
  { standard: "RCS/GRS", material_code: "RM0444" },
  { standard: "RCS/GRS", material_code: "RM0446" },
  { standard: "RCS/GRS", material_code: "RM0448" },
  { standard: "RCS/GRS", material_code: "RM0480" },
  { standard: "RCS/GRS", material_code: "RM0450" },
  { standard: "RCS/GRS", material_code: "RM0452" },
  { standard: "RCS/GRS", material_code: "RM0454" },
  { standard: "RCS/GRS", material_code: "RM0456" },
  { standard: "RCS/GRS", material_code: "RM0458" },
  { standard: "RCS/GRS", material_code: "RM0460" },
  { standard: "RCS/GRS", material_code: "RM0462" },
  { standard: "RCS/GRS", material_code: "RM0464" },
  { standard: "RCS/GRS", material_code: "RM0466" },
  { standard: "RCS/GRS", material_code: "RM0468" },
  { standard: "RCS/GRS", material_code: "RM0470" },
  { standard: "RCS/GRS", material_code: "RM0472" },
  { standard: "RCS/GRS", material_code: "RM0474" },
  { standard: "RCS/GRS", material_code: "RM0476" },
  { standard: "RCS/GRS", material_code: "RM0478" },
  { standard: "RCS/GRS", material_code: "RM0482" },
  { standard: "RCS/GRS", material_code: "RM0484" },
  { standard: "RCS/GRS", material_code: "RM0486" },
  { standard: "RCS/GRS", material_code: "RM0488" },
  { standard: "RCS/GRS", material_code: "RM0490" },
  { standard: "RCS/GRS", material_code: "RM0492" },
  { standard: "RCS/GRS", material_code: "RM0494" },
  { standard: "RCS/GRS", material_code: "RM0496" },
  { standard: "RCS/GRS", material_code: "RM0498" },
  { standard: "RCS/GRS", material_code: "RM0500" },
  { standard: "RCS/GRS", material_code: "RM0502" },
  { standard: "RCS/GRS", material_code: "RM0504" },
  { standard: "RCS/GRS", material_code: "RM0506" },
  { standard: "RCS/GRS", material_code: "RM0508" },
  { standard: "RCS/GRS", material_code: "RM0510" },
  { standard: "RCS/GRS", material_code: "RM0512" },
  { standard: "RCS/GRS", material_code: "RM0514" },
  { standard: "RCS/GRS", material_code: "RM0516" },
  { standard: "RCS/GRS", material_code: "RM0518" },
  { standard: "RCS/GRS", material_code: "RM0520" },
  { standard: "RCS/GRS", material_code: "RM0522" },
  { standard: "RCS/GRS", material_code: "RM0436" },
  { standard: "RCS/GRS", material_code: "RM0524" },
  { standard: "RCS/GRS", material_code: "RM0526" },
  { standard: "RCS/GRS", material_code: "RM0528" },
  { standard: "RCS/GRS", material_code: "RM0530" },
  { standard: "RCS/GRS", material_code: "RM0532" },
  { standard: "RCS/GRS", material_code: "RM0534" },
  { standard: "RCS/GRS", material_code: "RM0536" },
  { standard: "RCS/GRS", material_code: "RM0538" },
  { standard: "RCS/GRS", material_code: "RM0540" },
  { standard: "RCS/GRS", material_code: "RM0544" },
  { standard: "RCS/GRS", material_code: "RM0546" },
  { standard: "RCS/GRS", material_code: "RM0548" },
  { standard: "RCS/GRS", material_code: "RM0550" },
  { standard: "RCS/GRS", material_code: "RM0552" },
  { standard: "RCS/GRS", material_code: "RM0554" },
  { standard: "RCS/GRS", material_code: "RM0556" },
  { standard: "RCS/GRS", material_code: "RM0558" },
  { standard: "RCS/GRS", material_code: "RM0560" },
  { standard: "RCS/GRS", material_code: "RM0562" },
  { standard: "RCS/GRS", material_code: "RM0564" },
  { standard: "RCS/GRS", material_code: "RM0566" },
  { standard: "RCS/GRS", material_code: "RM0568" },
  { standard: "RCS/GRS", material_code: "RM0570" },
  { standard: "RCS/GRS", material_code: "RM0574" },
  { standard: "RCS/GRS", material_code: "RM0576" },
  { standard: "RCS/GRS", material_code: "RM0578" },
  { standard: "RCS/GRS", material_code: "RM0542" },
  { standard: "RCS/GRS", material_code: "RM0572" },
  { standard: "RCS/GRS", material_code: "RM0580" },
  { standard: "RCS/GRS", material_code: "RM0439" },
  { standard: "RCS/GRS", material_code: "RM0441" },
  { standard: "RCS/GRS", material_code: "RM0443" },
  { standard: "RCS/GRS", material_code: "RM0445" },
  { standard: "RCS/GRS", material_code: "RM0447" },
  { standard: "RCS/GRS", material_code: "RM0449" },
  { standard: "RCS/GRS", material_code: "RM0481" },
  { standard: "RCS/GRS", material_code: "RM0451" },
  { standard: "RCS/GRS", material_code: "RM0453" },
  { standard: "RCS/GRS", material_code: "RM0455" },
  { standard: "RCS/GRS", material_code: "RM0457" },
  { standard: "RCS/GRS", material_code: "RM0459" },
  { standard: "RCS/GRS", material_code: "RM0461" },
  { standard: "RCS/GRS", material_code: "RM0463" },
  { standard: "RCS/GRS", material_code: "RM0465" },
  { standard: "RCS/GRS", material_code: "RM0467" },
  { standard: "RCS/GRS", material_code: "RM0469" },
  { standard: "RCS/GRS", material_code: "RM0471" },
  { standard: "RCS/GRS", material_code: "RM0473" },
  { standard: "RCS/GRS", material_code: "RM0475" },
  { standard: "RCS/GRS", material_code: "RM0477" },
  { standard: "RCS/GRS", material_code: "RM0479" },
  { standard: "RCS/GRS", material_code: "RM0483" },
  { standard: "RCS/GRS", material_code: "RM0485" },
  { standard: "RCS/GRS", material_code: "RM0487" },
  { standard: "RCS/GRS", material_code: "RM0489" },
  { standard: "RCS/GRS", material_code: "RM0491" },
  { standard: "RCS/GRS", material_code: "RM0493" },
  { standard: "RCS/GRS", material_code: "RM0495" },
  { standard: "RCS/GRS", material_code: "RM0497" },
  { standard: "RCS/GRS", material_code: "RM0499" },
  { standard: "RCS/GRS", material_code: "RM0501" },
  { standard: "RCS/GRS", material_code: "RM0503" },
  { standard: "RCS/GRS", material_code: "RM0505" },
  { standard: "RCS/GRS", material_code: "RM0507" },
  { standard: "RCS/GRS", material_code: "RM0509" },
  { standard: "RCS/GRS", material_code: "RM0511" },
  { standard: "RCS/GRS", material_code: "RM0513" },
  { standard: "RCS/GRS", material_code: "RM0515" },
  { standard: "RCS/GRS", material_code: "RM0517" },
  { standard: "RCS/GRS", material_code: "RM0519" },
  { standard: "RCS/GRS", material_code: "RM0521" },
  { standard: "RCS/GRS", material_code: "RM0523" },
  { standard: "RCS/GRS", material_code: "RM0437" },
  { standard: "RCS/GRS", material_code: "RM0525" },
  { standard: "RCS/GRS", material_code: "RM0527" },
  { standard: "RCS/GRS", material_code: "RM0529" },
  { standard: "RCS/GRS", material_code: "RM0531" },
  { standard: "RCS/GRS", material_code: "RM0533" },
  { standard: "RCS/GRS", material_code: "RM0535" },
  { standard: "RCS/GRS", material_code: "RM0537" },
  { standard: "RCS/GRS", material_code: "RM0539" },
  { standard: "RCS/GRS", material_code: "RM0541" },
  { standard: "RCS/GRS", material_code: "RM0545" },
  { standard: "RCS/GRS", material_code: "RM0547" },
  { standard: "RCS/GRS", material_code: "RM0549" },
  { standard: "RCS/GRS", material_code: "RM0551" },
  { standard: "RCS/GRS", material_code: "RM0553" },
  { standard: "RCS/GRS", material_code: "RM0555" },
  { standard: "RCS/GRS", material_code: "RM0557" },
  { standard: "RCS/GRS", material_code: "RM0559" },
  { standard: "RCS/GRS", material_code: "RM0561" },
  { standard: "RCS/GRS", material_code: "RM0563" },
  { standard: "RCS/GRS", material_code: "RM0565" },
  { standard: "RCS/GRS", material_code: "RM0567" },
  { standard: "RCS/GRS", material_code: "RM0569" },
  { standard: "RCS/GRS", material_code: "RM0571" },
  { standard: "RCS/GRS", material_code: "RM0575" },
  { standard: "RCS/GRS", material_code: "RM0577" },
  { standard: "RCS/GRS", material_code: "RM0579" },
  { standard: "RCS/GRS", material_code: "RM0543" },
  { standard: "RCS/GRS", material_code: "RM0573" },
  { standard: "RCS/GRS", material_code: "RM0581" },
  // GOTS entries (appear at end of backend JSON)
  { standard: "GOTS", material_code: "RM0004" },
  { standard: "GOTS", material_code: "RM0011" },
  { standard: "GOTS", material_code: "RM0017" },
  { standard: "GOTS", material_code: "RM0023" },
  { standard: "GOTS", material_code: "RM0029" },
  { standard: "GOTS", material_code: "RM0036" },
  { standard: "GOTS", material_code: "RM0043" },
  { standard: "GOTS", material_code: "RM0049" },
  { standard: "GOTS", material_code: "RM0055" },
  { standard: "GOTS", material_code: "RM0061" },
  { standard: "GOTS", material_code: "RM0068" },
  { standard: "GOTS", material_code: "RM0074" },
  { standard: "GOTS", material_code: "RM0080" },
  { standard: "GOTS", material_code: "RM0087" },
  { standard: "GOTS", material_code: "RM0093" },
  { standard: "GOTS", material_code: "RM0099" },
  { standard: "GOTS", material_code: "RM0105" },
  { standard: "GOTS", material_code: "RM0111" },
  { standard: "GOTS", material_code: "RM0117" },
  { standard: "GOTS", material_code: "RM0123" },
  { standard: "GOTS", material_code: "RM0129" },
  { standard: "GOTS", material_code: "RM0135" },
  { standard: "GOTS", material_code: "RM0141" },
  { standard: "GOTS", material_code: "RM0147" },
  { standard: "GOTS", material_code: "RM0153" },
  { standard: "GOTS", material_code: "RM0157" },
  { standard: "GOTS", material_code: "RM0161" },
  { standard: "GOTS", material_code: "RM0165" },
  { standard: "GOTS", material_code: "RM0169" },
  { standard: "GOTS", material_code: "RM0175" },
  { standard: "GOTS", material_code: "RM0179" },
  { standard: "GOTS", material_code: "RM0183" },
  { standard: "GOTS", material_code: "RM0187" },
  { standard: "GOTS", material_code: "RM0191" },
  { standard: "GOTS", material_code: "RM0195" },
  { standard: "GOTS", material_code: "RM0199" },
  { standard: "GOTS", material_code: "RM0203" },
  { standard: "GOTS", material_code: "RM0207" },
  { standard: "GOTS", material_code: "RM0211" },
  { standard: "GOTS", material_code: "RM0215" },
  { standard: "GOTS", material_code: "RM0219" },
  { standard: "GOTS", material_code: "RM0223" },
  { standard: "GOTS", material_code: "RM0227" },
  { standard: "GOTS", material_code: "RM0231" },
  { standard: "GOTS", material_code: "RM0235" },
  { standard: "GOTS", material_code: "RM0239" },
  { standard: "GOTS", material_code: "RM0243" },
  { standard: "GOTS", material_code: "RM0247" },
  { standard: "GOTS", material_code: "RM0251" },
  { standard: "GOTS", material_code: "RM0255" },
  { standard: "GOTS", material_code: "RM0259" },
  { standard: "GOTS", material_code: "RM0265" },
  { standard: "GOTS", material_code: "RM0269" },
  { standard: "GOTS", material_code: "RM0273" },
  { standard: "GOTS", material_code: "RM0277" },
  { standard: "GOTS", material_code: "RM0281" },
  { standard: "GOTS", material_code: "RM0285" },
  { standard: "GOTS", material_code: "RM0289" },
  { standard: "GOTS", material_code: "RM0293" },
  { standard: "GOTS", material_code: "RM0297" },
  { standard: "GOTS", material_code: "RM0301" },
  { standard: "NA", material_code: "RM9999" },
  { standard: "GOTS", material_code: "RM0333" },
  { standard: "GOTS", material_code: "RM0340" },
  { standard: "GOTS", material_code: "RM0347" },
  { standard: "GOTS", material_code: "RM0354" },
  { standard: "GOTS", material_code: "RM0361" },
  { standard: "GOTS", material_code: "RM0368" },
  { standard: "GOTS", material_code: "RM0375" },
  { standard: "GOTS", material_code: "RM0382" },
  { standard: "GOTS", material_code: "RM0388" },
  { standard: "GOTS", material_code: "RM0395" },
  { standard: "GOTS", material_code: "RM0431" },
  { standard: "GOTS", material_code: "RM0582" },
  { standard: "GOTS", material_code: "RM0583" },
  // Multi-standard entries (same RM code appears under multiple standards)
  { standard: "RWS", material_code: "RM0357" },
  { standard: "RMS", material_code: "RM0357" },
  { standard: "RAS", material_code: "RM0357" },
  { standard: "RWS", material_code: "RM0364" },
  { standard: "RMS", material_code: "RM0385" },
  { standard: "RAS", material_code: "RM0425" },
];

/**
 * Filter RMS codes based on selected standards
 * @param selectedStandards - Array of selected standards from facility
 * @param allRmsCodes - Complete list of RMS code options with labels
 * @returns Filtered RMS codes that match the selected standards
 */
export const filterRmsCodesByStandard = (
  selectedStandards: string[],
  allRmsCodes: Array<{ value: string; label: string }>
): Array<{ value: string; label: string }> => {
  // If no standards selected, return all RMS codes (user hasn't selected a standard yet)
  if (!selectedStandards || selectedStandards.length === 0) {
    return allRmsCodes;
  }

  // Get all material codes that match any of the selected standards
  const applicableStandards = new Set<string>(selectedStandards);
  if (applicableStandards.has("MMS")) {
    ["RAS", "RCS", "GRS", "RCS/GRS", "RWS", "RMS"].forEach((std) => {
      applicableStandards.add(std);
    });
  }

  const applicableMaterialCodes = new Set<string>();
  RMS_STANDARD_MAPPING.forEach((mapping) => {
    // Handle standards with "/" like "RCS/GRS"
    const standards = mapping.standard.split("/").map((s) => s.trim());
    // Only include materials that match selected standards (exclude NA as it's not certified)
    if (standards.some((std) => applicableStandards.has(std)) && mapping.standard !== "NA") {
      applicableMaterialCodes.add(mapping.material_code);
    }
  });

  // Filter the passed-in RMS codes list to only include applicable materials
  return allRmsCodes.filter((rmsOption) =>
    applicableMaterialCodes.has(rmsOption.value)
  );
};

/**
 * Get standards applicable to a specific RMS code
 * @param rmCode - The RMS material code
 * @returns Array of standards that support this RMS code (excludes NA codes as they are not certified)
 */
export const getStandardsForRmsCode = (rmCode: string): string[] => {
  const standards = new Set<string>();
  RMS_STANDARD_MAPPING.forEach((mapping) => {
    if (mapping.material_code === rmCode) {
      // Handle standards with "/" like "RCS/GRS"
      mapping.standard.split("/").forEach((std) => {
        const trimmed = std.trim();
        standards.add(trimmed);
        if (["RAS", "RCS", "GRS", "RCS/GRS", "RWS", "RMS"].includes(trimmed)) {
          standards.add("MMS");
        }
      });
    }
  });
  return Array.from(standards);
};
